module.exports = __webpack_public_path__ + "media/images/athletes/2112-d60871c06ce177f607ce413ecd3f926f.png";